
import { Component, Vue, Prop } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import TableHead from '@/views/shop/order/index/com/table-head/index.vue'
import TableBody from '@/views/shop/order/index/com/table-body/index.vue'

@Component({
  components: {
    TableHead,
    TableBody,
  }
})
export default class extends ListViewVue {

  @Prop()
  userId: any;

  async getList() {
    return this.$post("/manager/order/list", {
      ...this.mesureData,
      userId: this.userId,
      // type 不传时后端默认为 1(待付款)，0 表示全部
      type: 0,
    });
  }
}
